/*
  Store Credit on the website.

  Two places show the same number — the chip in the header and the card on the
  account page — so there is one copy of it here and both read that one copy.

  The app learned why this matters the hard way: Home, Account and Checkout
  each fetched the balance themselves and kept their own, so after an order
  spent Rs 160 the account page said Rs 40 while the header still said Rs 200.
  From a customer's side that reads as the shop losing track of their money,
  which is the last thing a shop can afford to look like. The app's fix is in
  src/shopify/storeCredit.ts; this is the same fix, in plain script.
*/
(function () {
  'use strict';

  var cached = null;
  // Guards the account page and the header chip both asking in the same tick.
  var inFlight = null;

  function load() {
    if (cached) return Promise.resolve(cached);
    if (inFlight) return inFlight;
    if (!window.SP || !window.SP.isLoggedIn()) {
      return Promise.reject(new Error('Not logged in'));
    }

    inFlight = window.SP.storeCredit().then(
      function (info) {
        cached = info;
        inFlight = null;
        return info;
      },
      function (err) {
        // Not cached, so the next reader gets a fresh attempt rather than
        // inheriting this failure for the rest of the page's life.
        inFlight = null;
        throw err;
      }
    );
    return inFlight;
  }

  // Money is written the same way everywhere on this side of the shop, so a
  // balance never appears as Rs 1200 on one page and Rs 1,200 on the next.
  function rupees(amount) {
    return '₹' + Number(amount).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }

  window.SPCredit = { load: load, rupees: rupees };

  // The header chip, filled in only when there is credit to spend.
  //
  // The app shows its wallet chip at every balance, Rs 0 included, as a
  // standing reminder that Store Credit exists. The app's home screen has the
  // room for that; a phone header here does not — it already carries the
  // logo, search, the heart and the cart. So the card on the account page is
  // what shows at Rs 0 and explains what Store Credit is, and the header
  // speaks up only when the customer has some.
  function fillChip() {
    var chip = document.querySelector('[data-sp-credit-chip]');
    if (!chip) return;

    load()
      .then(function (info) {
        if (info.balanceRupees <= 0) return;
        chip.querySelector('[data-sp-credit-amount]').textContent = rupees(info.balanceRupees);
        chip.hidden = false;
      })
      .catch(function () {
        // Logged out, or the request failed. The chip stays hidden and
        // nothing else on the page depends on it.
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fillChip);
  } else {
    fillChip();
  }
})();
